import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';
import { calculatorSchema } from './calculatorSchema';
import { BEFORE_FOUNDATION_STAGE } from '@/constants/buc';
import {
  CI_LOAN_TO_VALUE,
  CI_MORTGAGE_INTEREST_RATE,
  LOAN_TENURE,
} from '@/constants/commercial-industrial/investment';

export const initialState = {
  formField: {
    stage: BEFORE_FOUNDATION_STAGE,
    rentalYears: '3',
    purchasePrice: '',
    loanTenure: LOAN_TENURE.DEFAULT.toString(),
    mortgageInterestRate: CI_MORTGAGE_INTEREST_RATE.DEFAULT.toString(),
    loanToValue: CI_LOAN_TO_VALUE.DEFAULT.toString(),
    rentalPerMonth: '',
    maintenanceFee: '',
    propertyTax: '',
    saleOfProperty: '',
    instalmentData: {
      topMI: 0,
      cscMI: 0,
      totalInstalment: 0,
    },
    outstandingLoan: 0,
    differenceInMIAndRentalFee: 0,
    differenceInCash: 0,
    totalMaintenanceFee: 0,
    afterOutstandingLoan: 0,
    totalDownpayment: 0,
    possibleReturns: 0,
    possibleReturnsPercentage: '',
  },
  loading: true,
};

export const commercialIndustrialInvestment = createSlice({
  name: 'ciInvestment',
  initialState,
  reducers: {
    updateFormField: (state, action: PayloadAction<z.infer<typeof calculatorSchema>>) => {
      state.formField = action.payload;
    },
  },
  extraReducers: () => {},
});

export const { updateFormField } = commercialIndustrialInvestment.actions;

export default commercialIndustrialInvestment.reducer;
